import { render, staticRenderFns } from "./SatisQuestions.vue?vue&type=template&id=0c9f4ec8&"
import script from "./SatisQuestions.vue?vue&type=script&lang=js&"
export * from "./SatisQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports